export default {
    setLoading: (state, loading) => { state.loading = loading },
    setLoadingOff: state => { state.loading = false },
    setLoadingOn: state => { state.loading = true },
    setCalculatorModel: (state, calculatorModel) => { state.calculatorModel = calculatorModel },
    setAlert: (state, alert) => { state.alert = alert },
    setUser: (state, user) => { state.user = user },
    setVeterinaryColleges: (state, veterinaryColleges) => { state.veterinaryColleges = veterinaryColleges },
    setIsDrugsManagement: (state, isDrugsManagement) => { state.isDrugsManagement = isDrugsManagement },
    setUserSection: (state, userSection) => { state.userSection = userSection },
    setLinkRedirect: (state, link_redirect) => { state.link_redirect = link_redirect },
    closeConfirmModel: (state) => { state.confirmModel.active = false },
    setConfirmModel: (state, { text, action, confirmText, closeText, parameters, cancelParameters, cancelAction, callback, active = true, alert = false, persistent = false }) => {
        state.confirmModel = { alert, active, text, action, confirmText, closeText, parameters, cancelParameters, cancelAction, callback, persistent }
    },
    setStepper: (state, stepper) => { state.stepper = stepper },
    setStepperTotal: (state, stepperTotal) => { state.stepperTotal = stepperTotal },
    setStepperData: (state, stepperData) => { state.stepperData = stepperData },
    setStepperModel: (state, stepperModel) => { state.stepperModel = stepperModel },
    setHomeAdds: (state, homeAdds) => { state.homeAdds = homeAdds },
    setEmailConfirmation: (state, emailConfirmation) => { state.emailConfirmation = emailConfirmation },
    setSectionsPanel: (state, sectionsPanelOpen) => { state.sectionsPanelOpen = !!sectionsPanelOpen },
}